var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1305_6656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 5.25V9.75H6.75",
    stroke: "#0a1b4a",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33656 17.9999C7.51582 19.1128 8.9969 19.8536 10.5947 20.1296C12.1926 20.4056 13.8363 20.2046 15.3206 19.5518C16.8049 18.899 18.0639 17.8232 18.9402 16.4589C19.8166 15.0947 20.2716 13.5024 20.2482 11.8811C20.2248 10.2597 19.7242 8.68123 18.8088 7.3428C17.8935 6.00437 16.604 4.96535 15.1015 4.35558C13.599 3.7458 11.9502 3.59231 10.3609 3.91427C8.77172 4.23623 7.31262 5.01937 6.16594 6.16584L2.25 9.74991",
    stroke: "#0a1b4a",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1305_6656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#0a1b4a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.d4264dcee1bdf7f6077047e70b222406.svg";
export { ForwardRef as ReactComponent };